import React from 'react'
import { CButton, CCard, CCardBody, CCol, CRow } from '@coreui/react'
import { useNavigate } from 'react-router-dom'
import WidgetsReminderMembership from '../widgets/WidgetsReminderMembership'

const Wizard3 = () => {
  let navigate = useNavigate()

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={12}>
              <div>
                <h1>.</h1>
              </div>
              <h4 id="traffic" className="card-title mb-0">
                <p id="caption 1">Reminder - Configuration Wizard - Memberships</p>
              </h4>
            </CCol>
          </CRow>
          <CRow>{/*<WidgetsDropdown />*/}</CRow>
        </CCardBody>
      </CCard>
      <WidgetsReminderMembership />
      <CCard>
        <CCardBody>
          <CRow>
            <CCol sm={12}>
              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <CButton
                  color="primary"
                  onClick={() => {
                    //localStorage.removeItem('loginName1')
                    //localStorage.removeItem('wizard')
                    //localStorage.setItem('wizard', 'User defined')
                    //console.log('User Configuration finished')
                    //console.log('User: ' + localStorage.getItem('account_ID'))
                    //console.log('Gender: ' + localStorage.getItem('gender'))
                    //console.log('Birthday: ' + localStorage.getItem('birthday'))
                    if (localStorage.getItem('membership') !== null) {
                      //  if (localStorage.getItem('birthday') !== null) {
                      //    console.log('NEXT Button pushed')
                      //createReminders()
                      navigate('/dashboard')
                      //  }
                    }
                  }}
                >
                  FINISH
                </CButton>
              </div>
            </CCol>
          </CRow>
          <CRow>{/*<WidgetsDropdown />*/}</CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default Wizard3
